import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Loading } from '../../../../../loadbar/Loading';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import {
  getTsunami as getTsunamiAc,
  getReferences as getReferencesAc,
  searchReferences as searchReferencesAc,
  createMarigram as createMarigramAc,
  getMarigram as getMarigramAc,
  updateMarigram as updateMarigramAc,
  clearMarigram as clearMarigramAc,
  searchTsunamis as searchTsunamisAc,
  getCountries as getCountriesAc,
  getLocations as getLocationsAc,
  getStates as getStatesAc,
  sortTsunamis as sortTsunamisAc,
  sortReferences as sortReferencesAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
  toggleReferenceColumns as toggleReferenceColumnsAc,
} from '../../../../../../redux/tsunamis/marigrams/edit/marigramEditActions';
import { marigramEditModel, createInitialForm, formToJson } from './marigramEditModel';
import { LabeledCheckbox } from '../../../../../form/LabeledCheckbox';
import { AssociatedReferenceControl } from '../../../../../form/AssociatedReferenceControl';
import { AssociatedTsunamiControl } from '../../../../../form/AssociatedTsunamiControl';
/* import { CommentsEditor } from '../../../../form/CommentsEditor'; */
import { EditForm } from '../../../../../form/EditForm';

const model = marigramEditModel.get('name');
const initialValues = marigramEditModel.get('initialValues');

class MarigramEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Marigram Edit';
    const {
      match: { params: { id } },
      getMarigram,
      getTsunami,
      getReferences,
      getCountries,
      getLocations,
      getStates,
      history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getMarigram({ id, history });
      getTsunami({ id, history });
      getReferences({ id, history });
    }
    getCountries({ history });
    getLocations({ history });
    getStates({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const {
      fetched, initializeForm, marigram,
    } = this.props;
    const { initialized } = this.state;
    if (!initialized) {
      if (fetched) {
        const form = createInitialForm(marigram);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearMarigram,
    } = this.props;
    clearMarigram();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, marigram,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original references.
    change('', createInitialForm(marigram));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine,
      updating,
      tsunami,
      searchTsunamis,
      tsunamiSearching,
      tsunamiSearchResults,
      references,
      searchReferences,
      referenceSearching,
      referenceSearchResults,
      countries,
      locations,
      states,
      match: { params: { id } },
      tsuSort,
      sortTsunamis,
      refSort,
      sortReferences,
      history,
      createMarigram,
      updateMarigram,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      marigram,
      toggleTsunamiColumns,
      tsuVisibleColumns,
      toggleReferenceColumns,
      refVisibleColumns,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }

    /*
    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();
    */

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle className="haz-page-card-title">{isAdd ? 'Add Runup' : `Edit Runup: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Marigram"
              saving={updating}
              create={createMarigram}
              update={updateMarigram}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={marigram}
            >

              <AssociatedTsunamiControl
                model={model}
                tsunami={tsunami}
                searchTsunamis={config => searchTsunamis({ ...config, history })}
                tsunamiSearching={tsunamiSearching}
                tsunamiSearchResults={tsunamiSearchResults}
                sort={tsuSort}
                sortData={sortTsunamis}
                visibleColumns={tsuVisibleColumns}
                toggleColumns={toggleTsunamiColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle>Date and Location</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-4']} model=".year" label="Year" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-sm-4']} model=".month" label="Month" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-sm-4']} model=".day" label="Day" readOnly={updating} />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="country" label="Country" readOnly={updating} filterable addable />
                    <LabeledSelect childOptions={locations.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="region" label="Region" readOnly={updating} filterable prependId />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={states.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="state" label="State" readOnly={updating} filterable addable />
                  </div>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle>Measurements</CardTitle>

                  <Card>
                    <CardBody>
                      <CardTitle>Travel Time</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-sm-6']} model=".travHours" label="Hours" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-sm-6']} model=".travMins" label="Minutes" readOnly={updating} />
                      </div>
                    </CardBody>
                  </Card>

                </CardBody>
              </Card>

              {/*
              <Card>
                <CardBody>
                  <CardTitle>Comments</CardTitle>
                  <CommentsEditor model={model} readOnly={updating} />
                </CardBody>
              </Card>
              */}

              <AssociatedReferenceControl
                model={model}
                initialReferences={references}
                searchReferences={config => searchReferences({ ...config, history })}
                referenceSearching={referenceSearching}
                referenceSearchResults={referenceSearchResults}
                sort={refSort}
                sortData={sortReferences}
                visibleColumns={refVisibleColumns}
                toggleColumns={toggleReferenceColumns}
              />

              {/*
              <Card>
                <CardBody>
                  <CardTitle>Checks</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".flagArrTravTimeChk" label="Arrival Time Checked" />
                    <LabeledCheckbox inline model=".flagLocChk" label="Location Checked" />
                    <LabeledCheckbox inline model=".flagRunupChk" label="Runup Checked" />
                    <LabeledCheckbox inline model=".flagEffectsChk" label="Effects Checked" />
                  </div>
                </CardBody>
              </Card>
              */}

              <Card>
                <CardBody>
                  <CardTitle>Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

MarigramEditPageUnwrapped.propTypes = {
  tsunami: ImmutablePropTypes.map.isRequired,
  getTsunami: PropTypes.func.isRequired,
  searchTsunamis: PropTypes.func.isRequired,
  tsunamiSearching: PropTypes.bool.isRequired,
  tsunamiSearchResults: ImmutablePropTypes.list.isRequired,
  references: ImmutablePropTypes.list.isRequired,

  getReferences: PropTypes.func.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  searchReferences: PropTypes.func.isRequired,

  marigram: ImmutablePropTypes.map.isRequired,
  clearMarigram: PropTypes.func.isRequired,
  createMarigram: PropTypes.func.isRequired,
  getMarigram: PropTypes.func.isRequired,
  updateMarigram: PropTypes.func.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  getCountries: PropTypes.func.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  getLocations: PropTypes.func.isRequired,
  states: ImmutablePropTypes.list.isRequired,
  getStates: PropTypes.func.isRequired,

  sortTsunamis: PropTypes.func.isRequired,
  tsuSort: ImmutablePropTypes.list.isRequired,
  sortReferences: PropTypes.func.isRequired,
  refSort: ImmutablePropTypes.list.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,

  toggleTsunamiColumns: PropTypes.func.isRequired,
  tsuVisibleColumns: ImmutablePropTypes.list.isRequired,
  toggleReferenceColumns: PropTypes.func.isRequired,
  refVisibleColumns: ImmutablePropTypes.list.isRequired,
};

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['marigramEditPage', 'fetchedRegions']),
    state.getIn(['marigramEditPage', 'fetchedCountries']),
    state.getIn(['marigramEditPage', 'fetchedAreas']),
    state.getIn(['marigramEditPage', 'fetchedLocations']),
    state.getIn(['marigramEditPage', 'fetchedFirstMotions']),
    state.getIn(['marigramEditPage', 'fetchedMeasurementTypes']),
  ];
  if (!isAdd) {
    fetchedCheck.push(
      state.getIn(['marigramEditPage', 'fetched']),
      state.getIn(['marigramEditPage', 'fetchedTsunami']),
      state.getIn(['marigramEditPage', 'fetchedReferences']),
    );
  }

  return {
    fetched: fetchedCheck.every(v => v),
    marigram: state.getIn(['marigramEditPage', 'marigram']),
    tsunami: state.getIn(['marigramEditPage', 'tsunami']),
    references: state.getIn(['marigramEditPage', 'references']),
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['marigramEditPage', 'updating']),
    referenceSearching: state.getIn(['marigramEditPage', 'referenceSearching']),
    referenceSearchResults: state.getIn(['marigramEditPage', 'referenceSearchResults']),
    tsunamiSearching: state.getIn(['marigramEditPage', 'tsunamiSearching']),
    tsunamiSearchResults: state.getIn(['marigramEditPage', 'tsunamiSearchResults']),
    countries: state.getIn(['marigramEditPage', 'countries']),
    locations: state.getIn(['marigramEditPage', 'locations']),
    states: state.getIn(['marigramEditPage', 'states']),
    tsuSort: state.getIn(['marigramEditPage', 'tsuSort']),
    refSort: state.getIn(['marigramEditPage', 'refSort']),
    formData: state.getIn(['marigramEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['marigramEditPage', 'editConfirmationOpen']),
    tsuVisibleColumns: state.getIn(['marigramEditPage', 'tsuVisibleColumns']),
    refVisibleColumns: state.getIn(['marigramEditPage', 'refVisibleColumns']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getTsunami: getTsunamiAc,
  sortTsunamis: sortTsunamisAc,
  searchTsunamis: searchTsunamisAc,
  getReferences: getReferencesAc,
  sortReferences: sortReferencesAc,
  searchReferences: searchReferencesAc,
  clearMarigram: clearMarigramAc,
  createMarigram: createMarigramAc,
  getMarigram: getMarigramAc,
  updateMarigram: updateMarigramAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: initial => actions.load(model, initial),
  setPristine: () => actions.setPristine(model),
  getCountries: getCountriesAc,
  getLocations: getLocationsAc,
  getStates: getStatesAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
  toggleReferenceColumns: toggleReferenceColumnsAc,
}, dispatch);

export const MarigramEditPage = connect(mapStateToProps, mapDispatchToProps)(MarigramEditPageUnwrapped);
